import { configureStore } from "@reduxjs/toolkit";
import apiReducer from "./api/apiSlice";
import uldReducer from "./api/UldExistsSlice"; 

import tableReducer from "./features/table/tableSlice"; 
import { forwarderService } from "./services/SPL"; 
import { airlineService } from "./services/SRC"; 
import { truckingService } from "./services/Trucking";
import { arfsmService } from "./services/ARFSM";
import { authService } from "./services/Auth";

//this middleware is used to console while dispatching so pore othano jete pare mainly for testing 
const loggerMiddleware = (store) => (next) => (action) => {
  console.log("Dispatching:", action);
  return next(action);
};

export const store = configureStore({
  reducer: {
    api: apiReducer,
    uld: uldReducer,

    table: tableReducer,
    [forwarderService.reducerPath]: forwarderService.reducer,
    [airlineService.reducerPath]: airlineService.reducer,
    [truckingService.reducerPath]: truckingService.reducer,
    [arfsmService.reducerPath]: arfsmService.reducer,
    [authService.reducerPath]: authService.reducer,
  },
 middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat([
    forwarderService.middleware,
    airlineService.middleware,
    truckingService.middleware,
    arfsmService.middleware,
    authService.middleware,
    ]),
});

export default store;